<template>
  <v-card class="pa-2 d-flex align-center rounded" outlined style="min-height: 64px;">
    <v-text-field v-model="searchText" label="Search" hide-details dense clearable solo flat
      prepend-inner-icon="mdi-magnify" class="rounded-pill flex-grow-1 mr-4" @input="emitSearch" />
    <div class="d-flex align-center" style="gap: 8px;">
      <v-select :items="columns" v-model="selectedColumn" label="Column" item-text="text" item-value="value" dense
        hide-details clearable style="min-width: 140px;" @change="emitSearch" />
      <v-select :items="searchModes" v-model="searchMode" placeholder="Search Mode" dense hide-details clearable
        style="min-width: 140px;" @change="emitSearch" />
    </div>
  </v-card>
</template>
<script>
export default {
  name: 'AdvancedSearchBar',
  props: {
    columns: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      searchText: '',
      selectedColumn: null,
      searchMode: null,
      searchModes: [
        'contains',
        'not contains',
        'starts with',
        'ends with',
        'not equals'
      ]
    }
  },
  methods: {
    emitSearch() {
      this.$emit('search', {
        column: this.selectedColumn,
        mode: this.searchMode || 'contains',
        text: this.searchText
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// TableFilter.vue?486f6927